import { PushpinFilled, PushpinOutlined } from '@ant-design/icons';
import { RGroupId, SubstituentId } from '@discngine/moosa-cheminformatics-data';
import { classNames } from '@discngine/moosa-common';
import { Button } from 'antd';
import React, { FC, useCallback } from 'react';

import { useSarMatrix } from '../SarMatrixContext';

import styles from './SarMatrixTable.module.less';

export interface ISarMatrixColumnLabelProps {
  isOptimizedMode: boolean;
  columnIndex: number;
  width: string;
  height: string;
  style: any;
  smiles: string;
  substituentId: SubstituentId;
  onPinIconClick: (axisId: RGroupId, id: SubstituentId) => void;
  axisId: RGroupId;
  locked: boolean;
}

export const SarMatrixColumnLabel: FC<ISarMatrixColumnLabelProps> = ({
  height,
  isOptimizedMode,
  columnIndex,
  smiles,
  style,
  width,
  substituentId,
  onPinIconClick,
  axisId,
  locked,
}) => {
  const { structureRenderer: StructureRenderer } = useSarMatrix();

  const onPinClick = useCallback(() => {
    if (substituentId) {
      onPinIconClick(axisId, substituentId);
    }
  }, [substituentId, onPinIconClick, axisId]);

  return (
    <div
      className={classNames(styles.cellWrap, {
        [styles.optimizedMode]: isOptimizedMode,
        [styles.secondRow]: isOptimizedMode && columnIndex % 2 !== 0,
      })}
      style={{
        ...style,
        width: width,
        marginLeft: isOptimizedMode ? `${style.width}px` : undefined,
      }}
    >
      <div
        className={classNames(styles.cell, {
          [styles.columnLabelCellInOptimizedMode]: isOptimizedMode,
        })}
        style={{
          height: height,
          width: width,
        }}
      >
        <div
          className={classNames({
            [styles.lockedCellHeader]: locked,
            [styles.cellHeader]: !locked,
          })}
        >
          <Button
            className={styles.pinButton}
            ghost={true}
            icon={locked ? <PushpinFilled /> : <PushpinOutlined />}
            size="small"
            onClick={onPinClick}
          />
        </div>

        <StructureRenderer key={columnIndex} smiles={smiles} />
      </div>
    </div>
  );
};
